"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASH_CHAR_REGEX = exports.O_CHAR_REGEX = exports.DOT_CHAR_REGEX = exports.PIPE_CHAR_REGEX = exports.UNDERSCORE_CHAR_REGEX = exports.FACET_VALUE_SEPARATOR = exports.RANGE_FACET_SEPARATOR = exports.FACET_SEPARATOR = void 0;
/* eslint-disable no-useless-escape */
/* This code parses the new-format PLP URL structure */
var types_1 = require("../../Types/types");
var helpers_1 = require("../helpers");
exports.FACET_SEPARATOR = '--';
exports.RANGE_FACET_SEPARATOR = '---';
exports.FACET_VALUE_SEPARATOR = '+';
exports.UNDERSCORE_CHAR_REGEX = /_/g;
exports.PIPE_CHAR_REGEX = /\|/g;
exports.DOT_CHAR_REGEX = /\./g;
exports.O_CHAR_REGEX = /-o-/g;
exports.DASH_CHAR_REGEX = /-/g;
// Convert underscores to hyphens (for facet values)
// Also temporary fix to use pipe symbol to replace forward-slash in the url (DAD-2999)
function decodeFacetValue(value) {
    var decoded = decodeURIComponent(value);
    decoded = decoded.replace(exports.UNDERSCORE_CHAR_REGEX, '-');
    decoded = decoded.replace(exports.PIPE_CHAR_REGEX, '/');
    return decoded;
}
function getType(url) {
    var paths = url.pathname.split('/');
    if (Object.values(types_1.PageType).includes(paths[1])) {
        return paths[1];
    }
    return undefined;
}
function getPageName(url, type) {
    var _a;
    if (!type || !(0, helpers_1.hasPageName)(type)) {
        return undefined;
    }
    return decodeURIComponent(((_a = url.pathname.split('/')) === null || _a === void 0 ? void 0 : _a[2]) || '');
}
/* Extracts the categories and facets from the path.
   Facets are found by looking for a path element which contains a hyphen.
   Note that if a category contains a hyphen it will be encoded as %2d */
function extractCategoriesAndFacets(pathName, type) {
    var facetsFound = false;
    var categories = [];
    var facets = [];
    var path = pathName.split('/');
    path.forEach(function (value) {
        if (value.trim().length) {
            if (value.includes(exports.FACET_SEPARATOR))
                facetsFound = true;
            if (facetsFound) {
                facets.push(value);
            }
            else {
                categories.push(decodeURIComponent(value));
            }
        }
    });
    // Remove 1st path entry (type) from the categories as its not a category
    categories.shift();
    if ((0, helpers_1.hasDataAfterFacets)(type))
        categories.shift();
    return { categories: categories, facets: facets };
}
function getCategories(url, type) {
    var categories = extractCategoriesAndFacets(url.pathname, type).categories;
    return categories.length ? { id: categories[categories.length - 1], hierarchy: categories } : undefined;
}
function seoToCioTransform(str, isRangeFacet) {
    if (isRangeFacet) {
        return str
            .replace(/(\d+)\-(\d+)/g, '$1.$2')
            .replace(/^([\d\.]+)-and-above$/, '"$1"-"inf"')
            .replace(/^up-to-([\d\.]+)$/, '"-inf"-"$1"')
            .replace(/^([\d\.]+)-to-([\d\.]+)$/, '"$1"-"$2"');
    }
    return str
        .replace(/(\d+)\-(\d+)/g, '$1.$2')
        .replace(/-slash-/g, '/')
        .replace(/\-/g, ' ')
        .toLowerCase();
}
function getFacets(url, type) {
    var facets = extractCategoriesAndFacets(url.pathname, type).facets;
    var results = [];
    facets.forEach(function (facet) {
        var isRangeFacet = !!facet.match(/---/);
        var facetText = facet.split(isRangeFacet ? exports.RANGE_FACET_SEPARATOR : exports.FACET_SEPARATOR);
        var facetId = decodeURIComponent(facetText.shift() || '');
        var id = facetId.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
        if (facetText.length) {
            var facetIdText = facetText[0]
                .split(exports.FACET_VALUE_SEPARATOR)
                .map(function (itemStr) { return seoToCioTransform(itemStr, isRangeFacet); })
                .join(exports.FACET_VALUE_SEPARATOR);
            var facetIds = facetIdText.split(exports.FACET_VALUE_SEPARATOR);
            var values = facetIds.map(function (val) { return ({ id: decodeFacetValue(val), name: '' }); });
            results.push({
                id: id,
                name: '',
                values: values,
                isRangeFacet: isRangeFacet,
            });
        }
    });
    return results.length ? results : undefined;
}
function parse(url) {
    var domain = (0, helpers_1.getDomain)(url);
    var type = getType(url);
    var category = getCategories(url, type);
    var facets = getFacets(url, type);
    var sortOption = (0, helpers_1.getSort)(url);
    var pageNumber = (0, helpers_1.getPageNumber)(url);
    var numProducts = (0, helpers_1.getNumProducts)(url);
    var pageName = getPageName(url, type);
    var unfilteredFacet = (0, helpers_1.getUnfilteredFacet)(url, { category: category, facets: facets, type: type });
    return { domain: domain, type: type, category: category, facets: facets, sortOption: sortOption, pageNumber: pageNumber, numProducts: numProducts, pageName: pageName, unfilteredFacet: unfilteredFacet };
}
exports.default = parse;
